import { Renderer } from '@ancienttech/glass';
import { mat4 } from 'gl-matrix';

export default class GBufferRenderer extends Renderer {
    constructor(context, mesh) {
        super(context);
        this.mesh = mesh;
    }

    async customInitAsync() {
        this.program = await this.context.loadProgramAsync(require('../shaders/gbuffer.vert'), require('../shaders/gbuffer.frag'), ["in_position", "in_textureCoord"], ["u_texture0", "u_modelMatrix", "u_viewMatrix", "u_projectionMatrix"]);
        this.textures = await this.context.loadTexturesAsync([
            {url:require('../textures/39_slab marble breciia aurora texture-seamless.jpg'), minFilter:this.context.gl.LINEAR, wrap:this.context.gl.REPEAT}
        ]);
        this.vao = this.mesh.makeDrawVao({ positions: this.program.attributes.in_position, colorUV: this.program.attributes.in_textureCoord });
    }

    destroy() {
        super.destroy();
        const GL = this.context.gl;
        this.vao.destroy();
        for (let texture of this.textures) {
            GL.deleteTexture(texture);
        }
        this.program.destroy();
    }

    customRender(frameInfo, mountBufferFunc, properties) {
        mountBufferFunc();

        const GL = this.context.gl;
        GL.enable(GL.CULL_FACE);
        GL.cullFace(GL.BACK);
        GL.enable(GL.DEPTH_TEST);

        GL.useProgram(this.program.program);
        this.context.bindTextures(this.textures, [this.program.uniforms.u_texture0]);

        GL.uniformMatrix4fv(this.program.uniforms.u_viewMatrix, false, properties.matrices.view);
        GL.uniformMatrix4fv(this.program.uniforms.u_projectionMatrix, false, properties.matrices.projection);

        GL.uniformMatrix4fv(this.program.uniforms.u_modelMatrix, false, mat4.create());
        this.vao.draw();
    }
}